import axios from 'axios';

export const MAX_COMPRESSION_PASSES = 2;
export const MAX_CONCURRENT_COMPRESSION_REQUESTS = 2;

export const createCompressionSessionId = () => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID().replace(/-/g, '');
  }

  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
};

export const getPdfSizes = async (documentIds, orderId) => {
  const { data } = await axios.post('/api/pdf-compression/sizes', {
    documentIds,
    orderId,
  });
  return data;
};

export const createPdfCompressionPreview = async ({ documentId, orderId, compressionSessionId }) => {
  const { data } = await axios.post(
    '/api/pdf-compression/preview',
    { documentId, orderId, compressionSessionId },
    { timeout: 180000 }
  );
  return data;
};

export const savePdfCompressionArtifacts = async ({ orderId, compressionSessionId, artifactIds }) => {
  const { data } = await axios.post('/api/pdf-compression/save', {
    orderId,
    compressionSessionId,
    artifactIds,
  });
  return data;
};

export const cleanupPdfCompressionArtifacts = ({ compressionSessionId, artifactIds }) =>
  axios.post('/api/pdf-compression/artifacts/cleanup', {
    compressionSessionId,
    artifactIds,
  });

export const runWithConcurrency = async (items, worker, concurrency, onComplete) => {
  const results = new Array(items.length);
  let nextIndex = 0;
  const workerCount = Math.min(Math.max(concurrency, 1), items.length);

  const runWorker = async () => {
    while (true) {
      const index = nextIndex;
      nextIndex += 1;
      if (index >= items.length) {
        return;
      }

      try {
        results[index] = { value: await worker(items[index]) };
      } catch (exception) {
        results[index] = { exception };
      } finally {
        onComplete?.();
      }
    }
  };

  await Promise.all(Array.from({ length: workerCount }, () => runWorker()));
  return results;
};

export const getCompressionFailureStatus = exception => {
  const status = exception?.response?.status;
  if (status === 400 || status === 404) {
    return 'permanent-error';
  }
  return 'transient-error';
};
